// extracted by mini-css-extract-plugin
export default {"video":"Video_video__mvo+8","contenedor":"Video_contenedor__92nyM"};